// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getQuestionTypeOpinometros as listQuestionTypesOpinometroAPI,
    getQuestionTypeOpinometro as getQuestionTypeOpinometroAPI,
    addQuestionTypeOpinometro as addQuestionTypeOpinometroAPI,
    updateQuestionTypeOpinometro as updateQuestionTypeOpinometroAPI,
    deleteQuestionTypeOpinometro as deleteQuestionTypeOpinometroAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { questionTypesOpinometroApiResponseError, questionTypesOpinometroApiResponseSuccess } from './actions';
import { QuestionTypesOpinometroActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getQuestionTypeOpinometro({ payload: { id } }) {
    try {
        const response = yield call(getQuestionTypeOpinometroAPI, id );
        const questionTypeOpinometroItem = response.data.data;
        yield put(questionTypesOpinometroApiResponseSuccess(QuestionTypesOpinometroActionTypes.GET_QUESTION_TYPE_OPINOMETRO, questionTypeOpinometroItem));
    } catch (error) {
        yield put(questionTypesOpinometroApiResponseError(QuestionTypesOpinometroActionTypes.GET_QUESTION_TYPE_OPINOMETRO, error));
    }
}

function* addQuestionTypeOpinometro({payload:questionTypeOpinometro}){
    try{
        const response = yield call(addQuestionTypeOpinometroAPI,{...questionTypeOpinometro})
        const questionTypeOpinometroItem = response.data
        yield put(questionTypesOpinometroApiResponseSuccess(QuestionTypesOpinometroActionTypes.ADD_QUESTION_TYPE_OPINOMETRO,questionTypeOpinometroItem))
    } catch(error){
        yield put(questionTypesOpinometroApiResponseError(QuestionTypesOpinometroActionTypes.ADD_QUESTION_TYPE_OPINOMETRO,error))
    }
}

function* updateQuestionTypeOpinometro({payload:questionTypeOpinometro}){
    try{
        const response = yield call(updateQuestionTypeOpinometroAPI,{...questionTypeOpinometro})
        const questionTypeOpinometroItem = response.data.data
        yield put(questionTypesOpinometroApiResponseSuccess(QuestionTypesOpinometroActionTypes.UPDATE_QUESTION_TYPE_OPINOMETRO,questionTypeOpinometroItem))
    }catch(error){
        yield put(questionTypesOpinometroApiResponseError(QuestionTypesOpinometroActionTypes.UPDATE_QUESTION_TYPE_OPINOMETRO,error))
    }
}
function* deleteQuestionTypeOpinometro({payload:{id}}){
    try{
        const response = yield call(deleteQuestionTypeOpinometroAPI,id)
        const questionTypeOpinometroItem = response.data.id
        yield put(questionTypesOpinometroApiResponseSuccess(QuestionTypesOpinometroActionTypes.DELETE_QUESTION_TYPE_OPINOMETRO,questionTypeOpinometroItem))
    }catch(error){
        yield put(questionTypesOpinometroApiResponseError(QuestionTypesOpinometroActionTypes.DELETE_QUESTION_TYPE_OPINOMETRO,error))
    }
}

/**
 * List contactos
 */
function* listQuestionTypesOpinometro({payload:params}) {
    try {
        const response = yield call(listQuestionTypesOpinometroAPI, { ...params });
        const listaQuestionTypesOpinometro = response.data.data;
        yield put(questionTypesOpinometroApiResponseSuccess(QuestionTypesOpinometroActionTypes.LIST_QUESTION_TYPES_OPINOMETRO, listaQuestionTypesOpinometro));
    } catch (error) {
        yield put(questionTypesOpinometroApiResponseError(QuestionTypesOpinometroActionTypes.LIST_QUESTION_TYPES_OPINOMETRO, error));
    }
}


export function* watchGetQuestionTypeOpinometro(): any {
    yield takeEvery(QuestionTypesOpinometroActionTypes.GET_QUESTION_TYPE_OPINOMETRO, getQuestionTypeOpinometro);
}

export function* watchListQuestionTypesOpinometro(): any {
    yield takeEvery(QuestionTypesOpinometroActionTypes.LIST_QUESTION_TYPES_OPINOMETRO, listQuestionTypesOpinometro);
}

export function* watchAddQuestionTypeOpinometro():any{
    yield takeEvery(QuestionTypesOpinometroActionTypes.ADD_QUESTION_TYPE_OPINOMETRO,addQuestionTypeOpinometro)
}
export function* watchUpdateQuestionTypeOpinometro():any{
    yield takeEvery(QuestionTypesOpinometroActionTypes.UPDATE_QUESTION_TYPE_OPINOMETRO,updateQuestionTypeOpinometro)
}
export function* watchDeleteQuestionTypeOpinometro():any{
    yield takeEvery(QuestionTypesOpinometroActionTypes.DELETE_QUESTION_TYPE_OPINOMETRO,deleteQuestionTypeOpinometro)
}


function* questionTypesOpinometroSaga(): any {
    yield all([
        fork(watchGetQuestionTypeOpinometro),
        fork(watchListQuestionTypesOpinometro),
        fork(watchAddQuestionTypeOpinometro),
        fork(watchUpdateQuestionTypeOpinometro),
        fork(watchDeleteQuestionTypeOpinometro),
    ]);
}

export default questionTypesOpinometroSaga;
